import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BranchResponseDto } from "../../shared/dtos/branch/BranchResponseDto";
import { BranchSummaryDto } from "../../shared/dtos/branch/BranchSummaryDto";
import {
  getInitialCrudState,
  generateCrudReducers,
  CrudState,
} from "../utils/crudFactory";

interface BranchState extends CrudState<BranchResponseDto, BranchSummaryDto> {
  loadingEmail: boolean;
  errorEmailing: string | null;
}

const initialState: BranchState = {
  ...getInitialCrudState<BranchResponseDto, BranchSummaryDto>(),
  loadingEmail: false,
  errorEmailing: null,
};

export const branchSlice = createSlice({
  name: "branch",
  initialState,
  reducers: {
    ...generateCrudReducers<BranchResponseDto, BranchSummaryDto>(),
    setLoadingEmail(state) {
      state.loadingEmail = true;
      state.errorEmailing = null;
    },
    setErrorEmailing(state, action: PayloadAction<string | null>) {
      state.loadingEmail = false;
      state.errorEmailing = action.payload;
    },
    setEmailSuccess(state) {
      state.loadingEmail = false;
    },
  },
});

export const branchActions = branchSlice.actions;
export default branchSlice.reducer;
